export class AuthenticationModel {
    public set accountId(value: string) {
        window.localStorage.setItem('accountId', value);
    }

    public get accountId(): string {
        return window.localStorage.getItem('accountId') || '';
    }

    public get isLoggedIn(): boolean {
        return !!this.accountId;
    }

    public removeAccountId() {
        window.localStorage.removeItem('accountId');
    }

    public removeAuthData() {
        this.removeAccountId();
    }
}
